<template>
  <div class="news">
    <div class="banner">
      <img src="@/assets/images/banner25.png">
    </div>
    <div class="banner">
      <img src="@/assets/images/banner28.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/images/banner14.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/images/banner15.jpg">
    </div>
  </div>
</template>
<script>
export default {
  name: 'LeftNews'
}
</script>
<style lang="scss" scoped>
.news {
  overflow: hidden;

  .iframe-1 {
    border: 0;
    height: 1830px;
    margin-top: -100px;
    pointer-events: none;
    overflow: hidden;
  }
}

@media screen and (max-width: 600px) {
  .news {
    margin-top: 15px;
    .iframe-1 {
      //margin-top: -380px;
      height: 1840px;
    }
  }
}
</style>
